import { useState } from "react";
import { Button } from "antd";
import { DeleteBillingModal } from "./deleteBillingModal";

export const ConfirmDeleteBillingButton = ({ onDelete, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const onConfirm = async () => {
    setLoading(true);

    try {
      await onDelete();
      setShowConfirmation(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        type="primary"
        danger
        disabled={loading}
        onClick={() => setShowConfirmation(true)}
        {...props}
      >
        Delete
      </Button>
      <DeleteBillingModal
        open={showConfirmation}
        loading={loading}
        onCancel={() => setShowConfirmation(false)}
        onDelete={onConfirm}
      />
    </>
  );
};
